import { cn } from '@/lib/utils';

import { ButtonColors, ButtonVariants } from '@/decodo/components/atoms/Button';
import { sharedStyles } from '@/decodo/components/atoms/Input';

export const variantColors: {
  [key in ButtonVariants]: { [key in ButtonColors]: string };
} = {
  filled: {
    primary:
      'text-base-dark-white bg-brand-500 hover:bg-brand-600 active:bg-brand-700',
    secondary:
      'text-base-white bg-gray-900 hover:bg-gray-800 active:bg-gray-700',
    white: 'text-base-black bg-base-white hover:bg-gray-100 active:bg-gray-200',
    destructive:
      'text-base-white bg-error-500 hover:bg-error-600 active:bg-error-700',
    tertiary:
      'text-base-white bg-tertiary-500 hover:bg-tertiary-600 active:bg-tertiary-700',
    gray: 'text-base-white bg-gray-500 hover:bg-brand-600 active:bg-brand-700',
  },
  outlined: {
    primary:
      'text-brand-500 bg-transparent border-brand-500 border boder-solid hover:shadow-border-px hover:shadow-brand-500 active:bg-brand-50 disabled:border-gray-500 disabled:text-gray-500 disabled:bg-transparent',
    secondary:
      'text-base-black bg-transparent border-base-black border boder-solid hover:shadow-border-px hover:shadow-base-black active:bg-gray-100',
    white:
      'text-base-white bg-transparent border-base-white border boder-solid hover:shadow-border-px hover:shadow-base-white active:bg-gray-800',
    destructive:
      'text-error-500 bg-transparent border-error-500 border boder-solid hover:shadow-border-px hover:shadow-error-500 active:bg-error-50',
    tertiary:
      'text-tertiary-500 bg-transparent border-tertiary-500 border boder-solid hover:shadow-border-px hover:shadow-tertiary-500 active:bg-tertiary-50',
    gray: 'text-gray-500 bg-transparent border-brand-500 border boder-solid hover:shadow-border-px hover:text-brand-500 hover:shadow-brand-500 active:bg-base-white disabled:!bg-base-white disabled:!text-brand-500',
  },
  text: {
    primary:
      'text-brand-500 bg-transparent hover:bg-brand-50 active:bg-brand-100',
    secondary:
      'text-base-black bg-transparent hover:bg-gray-50 active:bg-gray-200',
    white:
      'text-base-white bg-transparent hover:bg-gray-800 active:bg-gray-700',
    destructive:
      'text-error-500 bg-transparent hover:bg-error-50 active:bg-error-100',
    tertiary:
      'text-tertiary-500 bg-transparent hover:bg-tertiary-50 active:bg-tertiary-100',
    gray: 'text-gray-500 bg-transparent hover:text-brand-500 hover:border hover:border-brand-500 active:bg-base-white',
  },
  input: {
    primary: cn('hover:shadow-none justify-start', sharedStyles),
    secondary: cn('hover:shadow-none justify-start', sharedStyles),
    white: cn('hover:shadow-none justify-start', sharedStyles),
    destructive: cn('hover:shadow-none justify-start', sharedStyles),
    tertiary: cn('hover:shadow-none justify-start', sharedStyles),
    gray: cn('hover:shadow-none justify-start', sharedStyles),
  },
} as const;
